import React from "react";
import { MessageCircle } from "lucide-react";
import { useSite } from "@/lib/api";

export const WhatsAppFloat = () => {
  const { data: site } = useSite();
  if (!site?.whatsapp) return null;

  const url = `https://wa.me/${site.whatsapp}?text=${encodeURIComponent(
    `Merhaba ${site.brand}, sipariş vermek / bilgi almak istiyorum.`
  )}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp ile sipariş ver"
      className="group fixed bottom-24 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-lg shadow-black/40 transition-transform duration-200 hover:scale-110"
    >
      <MessageCircle className="h-7 w-7 text-black" />
      <span className="pointer-events-none absolute right-16 whitespace-nowrap rounded-full bg-black/80 px-3 py-1.5 text-xs font-medium text-white opacity-0 transition-opacity duration-200 group-hover:opacity-100">
        WhatsApp Sipariş Ver
      </span>
      <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366]/40" />
    </a>
  );
};

export default WhatsAppFloat;
